import React, { useState, useEffect, forwardRef, useImperativeHandle, useContext } from "react";
import { Drawer, Form, Icon, Radio, Select, DatePicker, Checkbox, notification, Button } from "antd";
import moment from "moment";
import axios from "axios";

import UploadAnexo from "../../../shared/components/Form/UploadAnexo";
import DownloadAnexo from "../../../shared/components/Form/DownloadAnexo";
import FormItemEstabelecimentos from "./Componentes/Estabelecimento";
import FormItemEdicao from "./Componentes/Edicao";
import FormItemTurma from "./Componentes/Turma";
import FormItemDisciplinas from "./Componentes/Disciplinas";

import { GlobalContext } from "../../../app/providers/GlobalState";

const RadioGroup = Radio.Group;
const { Option } = Select;

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const Transferencias = forwardRef(
    (
        {
            alunoSelecionado,
            alunoSemEscola,
            visible,
            onClose,
            form,
            handleChangeData,
            handleChangeSelectEstabelecimento,
            handleChangeSelectEdicao,
            handleChangeTodas,
            handleChangeSelectDisciplinas,
            handleChangeSelectTurma,
            handleChangeTipo,
            handleChangeSelectTipo,
            estabelecimentos,
            estabelecimentoSelecinado,
            edicoes,
            tipo,
            tipoTransferencia,
            dataTansferencia,
            edicaoSelecinado,
            turmaSelecinada,
            turmas,
            disciplinas,
            disciplinasSelecionadas,
            todasDisciplinas,
            indeterminate,
            tipoDocumento,
            handlerChangeFileList
        },
        ref
    ) => {
        //const [tipoDocumento, setTipoDocumento] = useState(1);
        const [fileList, setFileList] = useState([]);
        const [docGerado, setDocGerado] = useState("");
        const [nomeDocGerado, setNomeDocGerado] = useState("");
        const [loading, setLoading] = useState(false);
        const [aGerarDoc, setAGerarDoc] = useState(false);
        const [help, setHelp] = useState();
        const [validateStatus, setValidateStatus] = useState();

        const [message, setMessage] = useState("");

        const context = useContext(GlobalContext);

        const { getFieldDecorator, validateFields } = form;

        useImperativeHandle(ref, () => ({
            validateFields: () => validateFields() // Expondo o método validateFields
        }));

        const gerarDoc = () => {
            setLoading(true);

            var item = new FormData();
            item.append("utilizadorId", alunoSelecionado);
            item.append("dataEmissao", moment(dataTansferencia).format("YYYY-MM-DD"));

            axios({
                method: "post",
                url: "/api/pdf/transferencia",
                data: item
            })
                .then(async response => {
                    const { url, fileName } = response.data;
                    const file = await fetchFileFromURL(url);
                    setFileList([file]);
                    setDocGerado(url);
                    setNomeDocGerado(fileName);
                    setLoading(false);
                    setValidateStatus("");
                    setHelp("");
                })
                .catch(error => {
                    openNotificationWithIcon("error", "Erro", error.response.data);
                    setLoading(false);
                });
        };

        const fetchFileFromURL = async url => {
            const response = await fetch(url);
            const blob = await response.blob();
            const file = new File([blob], "Documento.pdf", { type: "application/pdf" });
            return file;
        };

        useEffect(() => {
            if (tipoDocumento === 2) {
                gerarDoc();
            }
        }, [tipoDocumento]);

        useEffect(() => {
            handlerChangeFileList(fileList);
        }, [fileList]);

        let opcoesEntrada = [
            {
                value: "remanejamento",
                descricao: "Remanejamento para outra turma"
            }
        ];

        let opcoesSaida = [
            {
                value: "escola",
                descricao: "Transferência para outra escola"
            },
            {
                value: "indefinido",
                descricao: "Transferência sem definição de instituição"
            }
        ];

        if (alunoSemEscola) {
            opcoesSaida = [
                {
                    value: "entrada",
                    descricao: "Transferência de Entrada"
                }
            ];
        }

        return (
            <>
                <div className="bloco-info">
                    <Form className="form-add-curso" layout="horizontal">
                        <div className="bloco">
                            {tipoTransferencia === "remanejamento" && (
                                <>
                                    <Form.Item label="Tipo de Entrada">
                                        {getFieldDecorator("tipo", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "Campo obrigatório"
                                                }
                                            ],
                                            initialValue: tipo
                                        })(
                                            <Select placeholder="Selecionar" allowClear={true} onChange={handleChangeSelectTipo}>
                                                {opcoesEntrada.map(op => (
                                                    <Option key={op.value}>{op.descricao}</Option>
                                                ))}
                                            </Select>
                                        )}
                                    </Form.Item>
                                    {tipo && (
                                        <>
                                            <FormItemEdicao
                                                {...{
                                                    edicaoSelecinado,
                                                    handleChangeSelectEdicao,
                                                    edicoes,
                                                    getFieldDecorator
                                                }}
                                                estabelecimentoSelecinado={context.estabelecimento.id}
                                            />
                                            <FormItemTurma
                                                {...{
                                                    turmaSelecinada,
                                                    handleChangeSelectTurma,
                                                    edicaoSelecinado,
                                                    turmas,
                                                    getFieldDecorator
                                                }}
                                            />
                                            {turmaSelecinada && (
                                                <FormItemDisciplinas
                                                    {...{
                                                        disciplinas,
                                                        todasDisciplinas,
                                                        indeterminate,
                                                        handleChangeTodas,
                                                        handleChangeSelectDisciplinas,
                                                        disciplinasSelecionadas,
                                                        getFieldDecorator
                                                    }}
                                                />
                                            )}
                                        </>
                                    )}
                                </>
                            )}
                            {tipoTransferencia === "transferencia" && (
                                <>
                                    <Form.Item label="Tipo de Transferência">
                                        {getFieldDecorator("tipo", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "Campo obrigatório"
                                                }
                                            ],
                                            initialValue: tipo
                                        })(
                                            <Select placeholder="Selecionar" allowClear={true} onChange={handleChangeSelectTipo}>
                                                {/*<Option key="escola">Transferência para outra escola</Option>*/}
                                                {/*<Option key="indefinido">Transferência sem definição de instituição</Option>*/}
                                                {opcoesSaida.map(op => (
                                                    <Option key={op.value}>{op.descricao}</Option>
                                                ))}
                                            </Select>
                                        )}
                                    </Form.Item>
                                    {tipo === "escola" && (
                                        <FormItemEstabelecimentos
                                            {...{
                                                estabelecimentoSelecinado,
                                                handleChangeSelectEstabelecimento,
                                                estabelecimentos,
                                                getFieldDecorator
                                            }}
                                        />
                                    )}
                                    {tipo === "entrada" && (
                                        <>
                                            <FormItemEdicao
                                                {...{
                                                    edicaoSelecinado,
                                                    handleChangeSelectEdicao,
                                                    edicoes,
                                                    getFieldDecorator
                                                }}
                                                estabelecimentoSelecinado={context.estabelecimento.id}
                                            />
                                            <FormItemTurma
                                                {...{
                                                    turmaSelecinada,
                                                    handleChangeSelectTurma,
                                                    edicaoSelecinado,
                                                    turmas,
                                                    getFieldDecorator
                                                }}
                                            />
                                            {turmaSelecinada && (
                                                <FormItemDisciplinas
                                                    {...{
                                                        disciplinas,
                                                        todasDisciplinas,
                                                        indeterminate,
                                                        handleChangeTodas,
                                                        handleChangeSelectDisciplinas,
                                                        disciplinasSelecionadas,
                                                        getFieldDecorator
                                                    }}
                                                />
                                            )}
                                        </>
                                    )}
                                </>
                            )}
                            <Form.Item label="Data">
                                {getFieldDecorator("dataTansferencia", {
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório"
                                        }
                                    ],
                                    initialValue: dataTansferencia
                                })(
                                    <DatePicker
                                        name="data"
                                        format="DD-MM-YYYY"
                                        placeholder="Selecionar"
                                        suffixIcon={false}
                                        clearIcon={false}
                                        onChange={date => {
                                            handleChangeData(date);
                                        }}
                                    />
                                )}
                            </Form.Item>
                            <Form.Item label="Documento">
                                <Radio.Group
                                    name="tipo_doc"
                                    className="drawer-doc-opcoes"
                                    value={tipoDocumento}
                                    onChange={handleChangeTipo}
                                >
                                    <Radio value={1}>Carregar</Radio>
                                    <Radio value={2}>Gerar</Radio>
                                </Radio.Group>
                            </Form.Item>
                            {tipoDocumento === 1 ? (
                                <UploadAnexo
                                    required={false}
                                    getFieldDecorator={getFieldDecorator}
                                    fileList={fileList}
                                    setFileList={setFileList}
                                    form={form}
                                />
                            ) : !docGerado ? (
                                <p>A gerar documento...</p>
                            ) : (
                                <DownloadAnexo
                                    docGerado={docGerado}
                                    nomeDocGerado={nomeDocGerado}
                                    setDocGerado={setDocGerado}
                                    setFileList={setFileList}
                                />
                            )}
                        </div>
                    </Form>
                    <div>
                        <p>{message}</p>
                    </div>
                </div>
            </>
        );
    }
);

export default Form.create()(Transferencias);
